<template>
  <div>
    <div
      v-if="!loading"
      class="background"
      :style="[
        windowWeight > 600
          ? { background: 'url(' + background + ') center' }
          : { background: 'url(' + backgroundMobile + ') center ' }
      ]"
    >
      <div class="container-top-right">
        <language-button style="float: left;"></language-button>

        <router-link to="/" class="navbar-brand brand-padding">
          <img alt="logo" title="logo" id="client-logo" :src="logo" />
        </router-link>
      </div>
      <div
        class="el-card box-card is-always-shadow text-center p-10"
        style="position: relative; margin: auto; width: 300px; z-index: 1; overflow: visible"
      >
        <br />
        <h1 class="f-normal f-16 title-menu">{{ title }} Portal</h1>
        <br />
        <div
          class="min-height"
          v-if="allow_registration || allow_results || allow_kit_registration"
        >
          <div v-if="this.$store.state.configs['ALLOW_ACCOUNTS']">
            <div class="form-group">
              <button
                @click="redirectLogin"
                class="button-home login"
                v-html="computeCaption(fields_en['login'], $store.state.lang.value.toLowerCase())"
              ></button>
            </div>
          </div>
          <div v-if="allow_registration && display_new_order_guest">
            <div class="form-group">
              <router-link
                role="link"
                :to="registerPath"
                tag="button"
                class="button-home register"
                v-html="this.$store.state.configs['ALLOW_ACCOUNTS'] ?
                  computeCaption(fields_en['register_as_a_new_patient_guest'], $store.state.lang.value.toLowerCase()) : computeCaption(fields_en['register_as_a_new_patient'], $store.state.lang.value.toLowerCase())
                "
              >
              </router-link>
            </div>
          </div>
          <div v-if="allow_registration && display_home_collection">
            <div class="form-group">
              <router-link
                role="link"
                :to="homeCollectionPath"
                tag="button"
                class="button-home home-collection"
                v-html="
                  computeCaption(fields_en['home_collection'], $store.state.lang.value.toLowerCase())
                "
              >
              </router-link>
            </div>
          </div>
          <div v-if="allow_results && display_results_guest">
            <div class="form-group">
              <router-link
                to="/patient/check-results"
                role="link"
                tag="button"
                class="button-home results"
                v-html="
                    computeCaption(fields_en['check_your_results'], $store.state.lang.value.toLowerCase())
                "
              >
              </router-link>
            </div>
          </div>
          <div v-if="allow_kit_registration && display_kit_guest">
            <div class="form-group">
              <router-link
                to="/patient/kit"
                tag="button"
                role="link"
                class="button-home kit"
                v-html="
                  computeCaption(fields_en['register_kit'], $store.state.lang.value.toLowerCase())
                "
              >
              </router-link>
            </div>
          </div>
          <div class="form-group" v-if="allow_go_pass && display_go_pass_guest">
            <router-link
              to="/go-pass"
              tag="button"
              role="link"
              class="button-home pass"
              v-html="
                  computeCaption(fields_en['go_pass'], $store.state.lang.value.toLowerCase())
                "
            >
            </router-link>
          </div>
          <div class="form-group" v-if="allow_quick_order && display_quick_order_guest">
            <router-link
              to="/self-order"
              tag="button"
              role="link"
              class="button-home quick"
              v-html="
                  computeCaption(fields_en['quick_order'], $store.state.lang.value.toLowerCase())
                "
            >
            </router-link>
          </div>
          <el-tooltip  placement="bottom" effect="light">
            <div slot="content" class="color:green">
              <span style="color:#509119;"> Build Timestamp: </span> {{this.buildTimeStamp}}
            </div>
            <span>v2.15</span>
          </el-tooltip>
      </div>
        <div v-else v-loading="true" class="loading min-height"></div>
      </div>
      <hr />
    </div>
    <div v-else v-loading="loading" class="loading"></div>
  </div>
</template>

<script>
import {FormatterUtils} from '../../../utils/Formatter'
import LanguageButton from './LanguageButton'
import axios from 'axios'
import { Input, Tooltip } from 'element-ui'
import {TranslationsUtils} from '../../../utils/Translations'

export default {
  data () {
    return {
      buildTimeStamp: '',
      registerPath: this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true ? '/patient/order' : '/patient/register',
      homeCollectionPath: this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true ? '/patient/order-home-collection' : '/patient/register-home-collection',
      loading: true,
      windowWeight: '',
      fields_en: {
        login: 'Login / Create New Account',
        register_as_a_new_patient: 'New Order',
        register_as_a_new_patient_guest: 'New Order As Guest',
        home_collection: 'Home Collection',
        check_your_results: 'Check your results',
        register_kit: 'Register Kit',
        go_pass: 'Go Pass',
        quick_order: 'Quick Order'
      },
      background: process.env.CLIENT_BACKGROUND,
      backgroundMobile: process.env.CLIENT_BACKGROUND_MOBILE,
      logo: process.env.CLIENT_LOGO
    }
  },
  mixins: [FormatterUtils, TranslationsUtils],
  components: {
    LanguageButton,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip
  },
  async beforeMount () {
    if (window.location.search.includes('code') && !localStorage.getItem('token')) {
      axios({
        url: process.env.SERVER_URI + '/token',
        method: 'post',
        data: {code: window.location.search.split('=').pop()}
      })
      .then((response) => {
        if (!response.data) {
          window.location.href = this.$store.state.configs.AWS_DOMAIN_NAME + '/login?response_type=code&client_id=' + this.$store.state.configs.AWS_CLIENT_ID + '&redirect_uri=' + this.$store.state.configs.AWS_REDIRECT_URL
        } else {
          localStorage.setItem('token', response.data['token'])
          localStorage.setItem('access_token', response.data['access_token'])
          localStorage.setItem('email', response.data['email'])
          localStorage.setItem('firstName', response.data['given_name'])
          localStorage.setItem('lastName', response.data['family_name'])
          window.location.href = window.origin + '/#/patient/account'
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    } else if (localStorage.getItem('token')) {
      window.location.href = window.origin + '/#/patient/account'
    } else {
      this.loading = false
    }
    window.document.title = this.title + ' Patient Portal - Home'
    await this.translateFields()
    this.buildTimeStamp = document.documentElement.dataset.buildTimestampUtc.replace('T', ' ').slice(0, -5)
  },
  mounted () {
    this.windowWeight = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWeight = window.innerWidth
    })
  },
  methods: {
    redirectLogin () {
      window.location.href = this.$store.state.configs.AWS_DOMAIN_NAME + '/login?response_type=code&client_id=' + this.$store.state.configs.AWS_CLIENT_ID + '&redirect_uri=' + this.$store.state.configs.AWS_REDIRECT_URL
    },
    translateFields () {
      axios({
        url: process.env.SERVER_URI + '/translation',
        method: 'get'
      })
        .then((response) => {
          this.$store.state.translation = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  computed: {
    title () {
      return this.$store.state.configs.LAB_NAME
    },
    allow_registration () {
      return this.isTrue(this.$store.state.configs.ALLOW_REGISTRATION)
    },
    allow_results () {
      return this.isTrue(this.$store.state.configs.ALLOW_RESULTS)
    },
    allow_kit_registration () {
      return this.isTrue(this.$store.state.configs.ALLOW_KIT_REGISTRATION)
    },
    allow_go_pass () {
      return this.isTrue(this.$store.state.configs.ALLOW_GO_PASS)
    },
    allow_quick_order () {
      return this.isTrue(this.$store.state.configs.ALLOW_SELF_ORDERING)
    },
    display_new_order_guest () {
      if (this.$store.state.configs.DISPLAY_NEW_ORDER_GUEST === undefined) {
        return true
      }
      return this.isTrue(this.$store.state.configs.DISPLAY_NEW_ORDER_GUEST)
    },
    display_home_collection () {
      if (this.$store.state.configs.DISPLAY_HOME_COLLECTION === undefined) {
        return false
      }
      return this.isTrue(this.$store.state.configs.DISPLAY_HOME_COLLECTION)
    },
    display_results_guest () {
      if (this.$store.state.configs.DISPLAY_RESULTS_GUEST === undefined) {
        return true
      }
      return this.isTrue(this.$store.state.configs.DISPLAY_RESULTS_GUEST)
    },
    display_kit_guest () {
      if (this.$store.state.configs.DISPLAY_KIT_GUEST === undefined) {
        return true
      }
      return this.isTrue(this.$store.state.configs.DISPLAY_KIT_GUEST)
    },
    display_go_pass_guest () {
      if (this.$store.state.configs.DISPLAY_GO_PASS_GUEST === undefined) {
        return true
      }
      return this.isTrue(this.$store.state.configs.DISPLAY_GO_PASS_GUEST)
    },
    display_quick_order_guest () {
      if (this.$store.state.configs.DISPLAY_QUICK_ORDER_GUEST === undefined) {
        return true
      }
      return this.isTrue(this.$store.state.configs.DISPLAY_QUICK_ORDER_GUEST)
    }
  }
}
</script>

<style scoped>
.background {
  background-position: center center;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-size: cover !important;
  background-color: white;
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.container-top-right {
  position: fixed;
  top: 0;
  right: 0;
}

img {
  max-width: 200px;
  max-height: 40px;
  margin-right: 15px;
}

.language-select {
  float: left;
}

hr {
  border-top: 2px solid #c1c1c1;
  position: absolute;
  bottom: 32%;
  width: 100%;
  z-index: 0;
}

.min-height {
  min-height: 155px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.f-16 {
  font-size: 20px;
}

>>> .el-loading-parent--relative {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home.vue